class AdsApi {
    getFullAdData(locale, expiredAdId) {
        return fetch('/' + locale + '/ads/get-full-ad-data.json?id=' + expiredAdId)
            .then(function (response) {
                return response.json();
            });
    }

    getShallowAdData(locale, expiredAdId) {
        return fetch('/' + locale + '/ads/get-shallow-ad-data.json?id=' + expiredAdId)
            .then(function (response) {
                return response.json();
            });
    }

    getCreateOptions(locale) {
        return fetch('/' + locale + '/ads/create-options.json')
            .then(function (response) {
                return response.json();
            });
    }

    getAdFee(locale, productId, numberOfItems) {
        return fetch('/' + locale + '/ads/fee.json?productId=' + productId + '&numberOfItems=' + numberOfItems)
            .then(function (response) {
                return response.json();
            });
    }

    createAd(offerData, locale, csrfToken) {
        return fetch('/' + locale + '/ads/save.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken,
            },
            body: JSON.stringify(offerData),
            redirect: "manual"
        });
    }

    renewAd(offerData, locale, csrfToken) {
        return fetch('/' + locale + '/ads/renewAd.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken,
            },
            body: JSON.stringify(offerData),
            redirect: "manual"
        });
    }

    reconditionAd(offerData, locale, csrfToken) {
        return fetch('/' + locale + '/ads/reconditionAd.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken,
            },
            body: JSON.stringify(offerData),
            redirect: "manual"
        });
    }

    editAd(offerData, locale, csrfToken) {
        return fetch('/' + locale + '/ads/edit/' + offerData.id + '.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken,
            },
            body: JSON.stringify(offerData),
            redirect: "manual"
        });
    }
}

export default new AdsApi();
